module.exports = __webpack_public_path__ + "static/img/son1_active.baa8db87.png";